import { useCallback } from 'react'
import { ModalSize } from '../../../../../_metronic/helpers'
import { useT } from '../../../../../_metronic/i18n/Metronici18n'
import { useModal } from '../../../../components'
import { getNotaVersaoById } from '../core/_requests'
import { NotaVersaoFormModal } from './NotaVersaoFormModal'

/** Abre o formulário de nota: sem `id` cria; com `id` busca o cadastro completo e edita. */
export const useAbrirFormNotaVersao = () => {
  const { showModal } = useModal()
  const { t } = useT()

  return useCallback(
    (id?: number) =>
      showModal({
        title: t(id ? 'notas_versao.form.titulo_editar' : 'notas_versao.form.titulo_nova'),
        content: <NotaVersaoFormModal id={id} />,
        size: ModalSize.Large,
        ...(id ? { fetchers: { nota: () => getNotaVersaoById(id) } } : {}),
      }),
    [showModal, t]
  )
}
